import { ExpedienteCorteEmmasaLineas } from './expedienteCorteEmmasaLineas.entity';
export class ExpedienteCorteEmmasa {
Numero: number;
ContratoCodigo: number;
FechaRegistro: Date;
FechaGeneracionOT: Date;
UsuarioOT: string;
FechaCorte: Date;
FechaAnulacion?: any;
FechaCierre?: any;
MotivoCierre?: any;
Observaciones?: any;
Usuario: string;
UsuarioMotCierre?: any;
TipoExpedienteCorteCodigo: number;
FechaEnvioBoe?: any;
FechaPublicacionBoe?: any;
Contrato?: any;
UsuarioBO?: any;
ExpedientesCorteTipo?: any;
Deuda: number;
CargoReconexion: number;
CargosAsociadosReconexion: number;
EstadoCargoReconexion: string;
EstadoCargosAsociadosReconexion: string;
EstadoExpedienteString: string;
ordenTrabajo?: any;
motivoCierre?: any;
ListaFacturasOrEfecPend: ExpedienteCorteEmmasaLineas[];
CodigoInmueble: number;
DireccionSuministro: string;
CodigoContrato: number;
VersionContrato: number;
ClienteContrato: string;
TipoDescripcion: string;
Cobrado: number;
ImportePendiente: number;
ImportePendienteToolTip: string;
}
